<template>
    <footer class="footer">
        <BContainer fluid>
            <BRow>
                <BCol col sm="6">
                    {{ new Date().getFullYear() }} © UNACS
                </BCol>
                <BCol col sm="6">
                    <div class="text-sm-end d-none d-sm-block">
                        Atılım Üniversitesi Yazılım Geliştirme Müdürlüğü
                    </div>
                </BCol>
            </BRow>
        </BContainer>
    </footer>
</template>
